export interface Drama {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  banner: string;
  shortIntro: string;
  synopsis: string;
  cast: string[];
  director: string;
  year: number;
  category: string;
  tags: string[];
  region: string;
  duration: string;
  rating: number;
  views: number;
  comments: number;
  updateDate: string;
  hot: boolean;
  featured: boolean;
  episodeCount: number;
  currentEpisode: number;
}

export const dramas: Drama[] = [
  {
    id: "kinnporsche",
    title: "黑帮少爷爱上我",
    subtitle: "Kinn × Porsche",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20handsome%20young%20Asian%20men%20in%20dark%20elegant%20suits%20standing%20close%20under%20warm%20golden%20light%2C%20moody%20romantic%20atmosphere%2C%20deep%20magenta%20and%20charcoal%20tones%2C%20soft%20bokeh%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-kinnporsche-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20poster%20of%20a%20Thai%20BL%20crime%20romance%2C%20two%20young%20Asian%20men%20in%20tailored%20dark%20suits%20standing%20in%20a%20moody%20luxury%20hallway%2C%20warm%20golden%20rim%20light%2C%20deep%20magenta%20and%20black%20tones%2C%20dramatic%20shadows%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=drama-kinnporsche-banner&orientation=landscape",
    shortIntro:
      "冷峻的黑帮继承人 Kinn 与桀骜的大学生 Porsche 因一场意外被迫绑定，从互相试探到生死相托，爱情在枪火与阴谋中悄然滋生。",
    synopsis:
      "Porsche 是热爱拳击的大学生，为补贴家用接下了一份保镖工作，却没料到雇主竟是让全城闻风丧胆的黑帮家族二少爷 Kinn。一场突如其来的追杀让两人被迫绑在一起，从针锋相对到并肩作战，身份的鸿沟、家族的暗流与致命的危险交织而来。在一次次生死边缘，他们逐渐看清彼此的脆弱与真心，也让这段跨越阶层的爱意愈发滚烫而危险。",
    cast: ["Mile Phakphum", "Apo Nattawin", "Bible Wichapas", "Build Jakapan"],
    director: "Krisda Witthayakhajorndet",
    year: 2022,
    category: "泰国腐剧",
    tags: ["双男主", "黑帮", "悬疑", "虐恋"],
    region: "泰国",
    duration: "每集约 55 分钟",
    rating: 9.1,
    views: 1286000,
    comments: 8642,
    updateDate: "2022-07-10",
    hot: true,
    featured: true,
    episodeCount: 14,
    currentEpisode: 14,
  },
  {
    id: "badbuddy",
    title: "是朋友还是男友",
    subtitle: "Pat × Pran",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20cheerful%20young%20Asian%20male%20university%20students%20in%20casual%20shirts%20smiling%20at%20each%20other%2C%20warm%20sunny%20campus%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-badbuddy-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20Thai%20BL%20campus%20romance%2C%20two%20young%20Asian%20male%20students%20in%20school%20uniforms%20standing%20side%20by%20side%20on%20a%20sunny%20walkway%2C%20warm%20golden%20afternoon%20light%2C%20soft%20rose%20and%20cream%20tones%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=drama-badbuddy-banner&orientation=landscape",
    shortIntro:
      "从小斗到大的死对头 Pat 与 Pran 考入同一所大学，被迫成为室友的两人，在吵闹与默契之间慢慢发现，彼此早已是对方最特别的存在。",
    synopsis:
      "Pat 与 Pran 是打小就互看不顺眼的邻居兼死对头，两家父母更是多年宿敌。命运却让两人考入同一所大学，甚至成了同一间宿舍的室友。从互不相让的较量，到合唱团里的并肩合作，再到深夜里不设防的心事交换，两人渐渐意识到那份较劲背后藏着别样的在意。当「是朋友还是男友」的问题摆在面前，他们必须直面心底最真实的答案。",
    cast: ["Ohm Pawat", "Nanon Korapat", "Jimmy Jitaraphol"],
    director: "Noppharnach Chaiwimol",
    year: 2021,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "暗恋", "治愈"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 9.0,
    views: 1182000,
    comments: 7311,
    updateDate: "2021-12-24",
    hot: true,
    featured: true,
    episodeCount: 12,
    currentEpisode: 12,
  },
  {
    id: "itold",
    title: "以你的心诠释我的爱",
    subtitle: "Teh × Oh-aew",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20gentle%20young%20Asian%20men%20standing%20by%20a%20sunset%20shore%2C%20breeze%20and%20soft%20warm%20light%2C%20tender%20romantic%20mood%2C%20rose%20gold%20and%20muted%20teal%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-itold-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20Thai%20BL%20romance%20by%20the%20sea%2C%20two%20young%20Asian%20men%20walking%20barefoot%20on%20a%20sunset%20beach%2C%20warm%20orange%20and%20rose%20sky%2C%20soft%20haze%2C%20emotional%20cinematic%20tone%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=drama-itold-banner&orientation=landscape",
    shortIntro:
      "青梅竹马的 Teh 与 Oh-aew 在普吉岛的夏天重逢，关于梦想、成长与勇气的故事里，藏着一句迟到许多年的告白。",
    synopsis:
      "在泰国南部的普吉岛，Teh 与 Oh-aew 是从小一起长大的玩伴，却因一场关于梦想的误会而渐行渐远。多年后两人在高考后的假期重逢，儿时的情谊在椰风海浪间重新被点燃。备试、争吵、和解与悸动交织，让 Teh 第一次认真面对自己的内心。这是一个关于青春、亲情与敢于承认爱意的故事，也是一封写给成长的情书。",
    cast: ["Billkin Putthipong", "PP Krit", "Khunakorn Sunthornchatchawan"],
    director: "Boss Naruebet",
    year: 2020,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "暗恋", "虐恋"],
    region: "泰国",
    duration: "每集约 60 分钟",
    rating: 9.3,
    views: 1428000,
    comments: 9014,
    updateDate: "2020-11-19",
    hot: true,
    featured: true,
    episodeCount: 5,
    currentEpisode: 5,
  },
  {
    id: "2gether",
    title: "假偶天成",
    subtitle: "Sarawat × Tine",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20handsome%20young%20Asian%20male%20students%20in%20white%20shirts%20holding%20guitars%2C%20bright%20cheerful%20campus%20mood%2C%20warm%20pink%20and%20soft%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-2gether-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20Thai%20BL%20campus%20romance%2C%20two%20young%20Asian%20men%20in%20smart%20white%20uniforms%20sitting%20on%20a%20university%20staircase%20with%20guitars%2C%20warm%20sunny%20light%2C%20pink%20and%20cream%20tones%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=drama-2gether-banner&orientation=landscape",
    shortIntro:
      "为了摆脱追求者，Tine 拉来冷酷的吉他手 Sarawat 假扮男友，一场「先假装再心动」的甜宠恋爱就此开场。",
    synopsis:
      "大学生 Tine 被同性追求者缠得头疼，情急之下谎称自己已有男友，而对象正是校园里人气极高却冷着一张脸的吉他手 Sarawat。两人约法三章开始「假情侣」营业，不料假戏渐渐成真。Sarawat 看似冷淡，实则藏着一段不为人知的暗恋往事。校园里的追逐、乐队演出与青涩约会，把这段关系一步步推向无法伪装的真心。",
    cast: ["Bright Vachirawit", "Win Metawin", "Frank Thanatsaran"],
    director: "Weerachit Thongjila",
    year: 2020,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "甜宠", "暗恋"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 8.7,
    views: 1564000,
    comments: 8120,
    updateDate: "2020-05-01",
    hot: true,
    featured: true,
    episodeCount: 13,
    currentEpisode: 13,
  },
  {
    id: "cutiepie",
    title: "甜心派",
    subtitle: "Lian × Kuea",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20elegant%20young%20Asian%20men%20in%20pastel%20luxury%20outfits%20standing%20close%20smiling%2C%20soft%20romantic%20sweet%20mood%2C%20blush%20pink%20and%20champagne%20gold%20tones%2C%20blurred%20bokeh%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-cutiepie-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20Thai%20BL%20romantic%20comedy%2C%20two%20young%20Asian%20men%20in%20pastel%20luxury%20suits%20standing%20in%20a%20bright%20modern%20ballroom%2C%20soft%20golden%20light%2C%20blush%20pink%20and%20cream%20tones%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=drama-cutiepie-banner&orientation=landscape",
    shortIntro:
      "被家族安排婚约的 Kuea 渴望自由，而未婚夫 Lian 却早已看穿他的一切伪装，一场甜甜的「追妻」拉锯就此展开。",
    synopsis:
      "Kuea 是备受宠爱的富家少爷，自小与商界继承人 Lian 定下婚约。为了保住自己的音乐梦想与自由，Kuea 白天是乖巧的未婚夫，夜晚却化身神秘的机车歌手，试图摆脱这门婚约。然而 Lian 远比想象中更了解他，一边不动声色地守护，一边用温柔又强势的方式拉近两人距离。谎言与心动交织，这段被安排的关系慢慢长出了真正的爱意。",
    cast: ["Zee Pruk", "Nunew Chawarin", "Nathee Suwannaroj"],
    director: "Ne Netipat",
    year: 2022,
    category: "泰国腐剧",
    tags: ["双男主", "甜宠", "豪门", "治愈"],
    region: "泰国",
    duration: "每集约 50 分钟",
    rating: 8.6,
    views: 986000,
    comments: 5230,
    updateDate: "2022-04-09",
    hot: true,
    featured: false,
    episodeCount: 12,
    currentEpisode: 12,
  },
  {
    id: "lovebychance",
    title: "不期而爱",
    subtitle: "Ae × Pete",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20students%20in%20soft%20pastel%20shirts%20in%20a%20gentle%20embrace%2C%20warm%20nostalgic%20campus%20mood%2C%20muted%20rose%20and%20beige%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-lovebychance-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20students%20in%20soft%20pastel%20shirts%20in%20a%20gentle%20embrace%2C%20warm%20nostalgic%20campus%20mood%2C%20muted%20rose%20and%20beige%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-lovebychance-cover&orientation=portrait",
    shortIntro:
      "温柔内向的 Pete 遇见了直率阳光的 Ae，一次次不期而遇的守护，让胆怯的心慢慢学会了勇敢。",
    synopsis:
      "Pete 是个家境优渥却敏感内向的大学生，长期被纠缠却不敢反抗。一次偶然，他被直率仗义的学弟 Ae 出手相助，两人由此结缘。Ae 的阳光与坚定一点点融化了 Pete 的防备，而 Pete 的温柔也让 Ae 第一次认真思考未来。在校园的日常与家庭的压力之间，这段不期而遇的感情经受着考验，也慢慢变得坚定。",
    cast: ["Saint Suppapong", "Perth Tanapon", "Plan Rathavit"],
    director: "New Siwaj",
    year: 2018,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "治愈", "甜宠"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 8.5,
    views: 764000,
    comments: 4102,
    updateDate: "2018-09-21",
    hot: false,
    featured: false,
    episodeCount: 14,
    currentEpisode: 14,
  },
  {
    id: "thousandstars",
    title: "千星传说",
    subtitle: "Phupha × Tian",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20men%20standing%20on%20a%20misty%20mountain%20under%20a%20starry%20sky%2C%20quiet%20tender%20atmosphere%2C%20deep%20plum%20and%20warm%20amber%20tones%2C%20soft%20glow%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-thousandstars-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20men%20standing%20on%20a%20misty%20mountain%20under%20a%20starry%20sky%2C%20quiet%20tender%20atmosphere%2C%20deep%20plum%20and%20warm%20amber%20tones%2C%20soft%20glow%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-thousandstars-cover&orientation=portrait",
    shortIntro:
      "因一颗心脏的馈赠而重获新生的 Tian 来到偏远山村支教，遇见了冷峻的护林军官 Phupha，在山野星空间懂得了爱与责任。",
    synopsis:
      "富家少爷 Tian 因心脏病接受了一场手术，也接下了捐赠者未完成的心愿——去偏远山区支教。在那里他遇见了守护村子的护林军官 Phupha，对方严厉寡言，却总在关键时刻出现。从最初的摩擦到彼此守护，Tian 在孩子们的笑声与山间的星空里慢慢找到人生的意义，也读懂了 Phupha 沉默背后的温柔。这是一段关于重生、信念与爱的故事。",
    cast: ["Earth Pirapat", "Mix Sahaphap", "Drake Laedeke"],
    director: "Aof Noppharnach",
    year: 2021,
    category: "泰国腐剧",
    tags: ["双男主", "治愈", "军旅", "暗恋"],
    region: "泰国",
    duration: "每集约 50 分钟",
    rating: 9.0,
    views: 892000,
    comments: 6033,
    updateDate: "2021-03-19",
    hot: false,
    featured: false,
    episodeCount: 10,
    currentEpisode: 10,
  },
  {
    id: "theoryoflove",
    title: "恋爱传播学",
    subtitle: "Khai × Third",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20film%20students%20with%20a%20camera%20and%20clapperboard%2C%20bittersweet%20romantic%20mood%2C%20muted%20rose%20and%20slate%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-theoryoflove-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20film%20students%20with%20a%20camera%20and%20clapperboard%2C%20bittersweet%20romantic%20mood%2C%20muted%20rose%20and%20slate%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-theoryoflove-cover&orientation=portrait",
    shortIntro:
      "Third 暗恋了花心的好友 Khai 整整三年，直到他决定放手，Khai 才第一次意识到，有些感情早该被认真对待。",
    synopsis:
      "电影系学生 Third 默默暗恋着好友 Khai 长达三年，却眼睁睁看着 Khai 一次次恋爱又分手，把自己当成永远的备胎与倾诉对象。心灰意冷的 Third 决定结束这场独角戏，转身投入自己的电影梦想。直到失去后，Khai 才开始重新审视这段关系。追逐、错过与和解，让两个人在胶片般的光影里，重新学会如何去爱一个人。",
    cast: ["Off Jumpol", "Gun Atthaphan", "White Nawat"],
    director: "Backaof",
    year: 2019,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "暗恋", "虐恋"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 8.8,
    views: 826000,
    comments: 5510,
    updateDate: "2019-08-17",
    hot: false,
    featured: false,
    episodeCount: 12,
    currentEpisode: 12,
  },
  {
    id: "tharntype",
    title: "与爱同居",
    subtitle: "Tharn × Type",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20roommates%20in%20a%20dorm%20standing%20close%20with%20mixed%20emotions%2C%20intense%20emotional%20mood%2C%20deep%20maroon%20and%20warm%20beige%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-tharntype-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20male%20roommates%20in%20a%20dorm%20standing%20close%20with%20mixed%20emotions%2C%20intense%20emotional%20mood%2C%20deep%20maroon%20and%20warm%20beige%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-tharntype-cover&orientation=portrait",
    shortIntro:
      "观念保守的 Type 与开朗的 Tharn 成了室友，从水火不容到彼此治愈，一段在摩擦中生长的爱情悄然发生。",
    synopsis:
      "新生 Type 有着难以言说的心理阴影，对亲密关系充满排斥，却在开学时被安排与开朗随和的学长 Tharn 同住一间宿舍。性格与观念的碰撞让两人摩擦不断，但随着朝夕相处，Type 慢慢发现 Tharn 的耐心与温柔。从对抗到理解，从戒备到依靠，这段关系治愈了彼此的伤口，也让两个人共同成长为更好的人。",
    cast: ["Mew Suppasit", "Gulf Kanawut", "Mild Anusara"],
    director: "Tee Bundit",
    year: 2019,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "虐恋", "治愈"],
    region: "泰国",
    duration: "每集约 50 分钟",
    rating: 8.4,
    views: 1342000,
    comments: 7712,
    updateDate: "2019-11-30",
    hot: false,
    featured: false,
    episodeCount: 12,
    currentEpisode: 12,
  },
  {
    id: "moonlightchicken",
    title: "月光鸡饭",
    subtitle: "Wen × Jim",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20men%20in%20a%20cozy%20night%20food%20stall%20sharing%20a%20quiet%20moment%2C%20warm%20lantern%20light%2C%20nostalgic%20tender%20mood%2C%20amber%20and%20deep%20teal%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-moonlightchicken-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20men%20in%20a%20cozy%20night%20food%20stall%20sharing%20a%20quiet%20moment%2C%20warm%20lantern%20light%2C%20nostalgic%20tender%20mood%2C%20amber%20and%20deep%20teal%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-moonlightchicken-cover&orientation=portrait",
    shortIntro:
      "在深夜不打烊的鸡饭小店里，疲惫的都市人 Jim 与迷茫的青年 Wen 相遇，一顿热饭的温度，慢慢焐热了两颗孤单的心。",
    synopsis:
      "Jim 经营着一家只开深夜的鸡饭小店，独自扛起照顾家人的重担。某个凌晨，进退两难的青年 Wen 走进了这家店，一碗热腾腾的鸡饭成了两人故事的起点。在城市的喧嚣与生活的重压之间，两人一次次在这间小店里相遇、倾诉、互相扶持。温暖的食物与慢下来的时光，让两段疲惫的人生重新找到了停靠的港湾。",
    cast: ["Mix Sahaphap", "Earth Pirapat", "First Kanaphan"],
    director: "Aof Noppharnach",
    year: 2023,
    category: "泰国腐剧",
    tags: ["双男主", "治愈", "深夜食堂", "都市"],
    region: "泰国",
    duration: "每集约 50 分钟",
    rating: 9.0,
    views: 548000,
    comments: 3390,
    updateDate: "2023-03-02",
    hot: false,
    featured: false,
    episodeCount: 8,
    currentEpisode: 8,
  },
  {
    id: "mygear",
    title: "我的齿轮和你",
    subtitle: "Pai × Itt",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20engineering%20students%20in%20blue%20work%20shirts%20laughing%20together%20on%20campus%2C%20warm%20youthful%20mood%2C%20soft%20coral%20and%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-mygear-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20young%20Asian%20engineering%20students%20in%20blue%20work%20shirts%20laughing%20together%20on%20campus%2C%20warm%20youthful%20mood%2C%20soft%20coral%20and%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-mygear-cover&orientation=portrait",
    shortIntro:
      "工科生 Pai 与转学生 Itt 从一场误会的较劲开始，在社团与考试的日常里，把青涩的心动慢慢变成了勇气。",
    synopsis:
      "工程学院的 Pai 是人人眼中的优等生，转学生 Itt 的到来却打乱了他按部就班的节奏。两人从一场误会开始互相较劲，又在社团活动与期末考试的并肩奋战中逐渐靠近。家庭的期望、未来的选择与青涩的心动交织在一起，让 Pai 和 Itt 必须学会直面自己。这是一个关于成长、勇气与陪伴的校园故事。",
    cast: ["Frank Thanatsaran", "Nanon Korapat", "Marc Pahun"],
    director: "New Siwaj",
    year: 2020,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "治愈", "甜宠"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 8.2,
    views: 426000,
    comments: 2480,
    updateDate: "2020-08-14",
    hot: false,
    featured: false,
    episodeCount: 12,
    currentEpisode: 12,
  },
  {
    id: "darkbluekiss",
    title: "深蓝之吻",
    subtitle: "Pete × Kao",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20handsome%20young%20Asian%20male%20university%20students%20in%20navy%20and%20white%20outfits%20standing%20close%20smiling%2C%20fresh%20romantic%20mood%2C%20deep%20rose%20and%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-darkbluekiss-cover&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20Thai%20BL%20drama%20poster%2C%20two%20handsome%20young%20Asian%20male%20university%20students%20in%20navy%20and%20white%20outfits%20standing%20close%20smiling%2C%20fresh%20romantic%20mood%2C%20deep%20rose%20and%20cream%20tones%2C%20blurred%20background%2C%20editorial%20photography%2C%20high%20detail&width=600&height=900&seq=drama-darkbluekiss-cover&orientation=portrait",
    shortIntro:
      "Pete 与 Kao 在校园里谈着甜蜜的恋爱，却要面对友情、误解与未来的考验，守护这份来之不易的深蓝之吻。",
    synopsis:
      "Pete 与 Kao 好不容易从朋友走到恋人，本以为可以安静地享受甜蜜，却不断被旁人的误解与旧日的纠葛打扰。面对朋友的猜疑、学业的压力与对未来的迷茫，两人必须一起学会坦诚与信任。一路的磨合与守护，让这段来之不易的感情愈发坚定，也让彼此成为对方最安心的依靠。",
    cast: ["Tay Tawan", "New Thitipoom", "Gun Atthaphan"],
    director: "Backaof",
    year: 2019,
    category: "泰国腐剧",
    tags: ["双男主", "青春校园", "甜宠", "治愈"],
    region: "泰国",
    duration: "每集约 45 分钟",
    rating: 8.6,
    views: 618000,
    comments: 3620,
    updateDate: "2019-09-14",
    hot: false,
    featured: false,
    episodeCount: 12,
    currentEpisode: 12,
  },
];